const VideoModal = (({ jQuery: $ }) => {
    class VideoModal {
        constructor($node) {
            this.$node = $($node);
            this.$closeBtn = null;
            this.$overlay = null;
            this.isOpenState = false;
        }

        initPlugin() {
            this.$node.inLarge({
                max_width: '90',
                percentage_width: true,
                speed: 600,
            });
        }

        customCloseBtn() {
            this.$closeBtn = $('#inlarge-close');
            this.$overlay = $('#inlarge-container');
            this.$closeBtn.text('').addClass('js-is-active hamburger');

            $('.hamburger-box')
                .clone()
                .appendTo(this.$closeBtn)
                .find('.menu-label')
                .remove();
        }

        toggleLockScroll(e) {
            this.removeEventBindings();

            this.isOpenState = !this.isOpenState;

            this.isOpenState
                ? $('body').css('overflow', 'hidden')
                : $('body').css('overflow', '');

            this.debounceClick();
        }

        debounceClick() {
            setTimeout(() => {
                this.setEventBindings();
            }, 500);
        }

        removeEventBindings() {
            this.$node
                .add(this.$closeBtn)
                .add(this.$overlay)
                .off('click.videoModal');
        }

        setEventBindings() {
            this.$node
                .add(this.$closeBtn)
                .add(this.$overlay)
                .on('click.videoModal', this.toggleLockScroll.bind(this));
        }

        init() {
            this.initPlugin();
            this.customCloseBtn();
            this.setEventBindings();
        }
    }

    return {
        init({ selector }) {
            return new VideoModal(selector).init();
        },
    };
})(window);

export default Object.create(VideoModal);
